<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">商家管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="160px" class="user-search">
            <el-form-item label="商家名称">
                <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="商家注册手机号">
                <el-input size="small" v-model="formInline.phone" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="nickname" label="商家名称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="phone" label="商家注册手机号" ></el-table-column>
            <el-table-column  prop="attestation" label="是否认证" >
                <template slot-scope="scope">
                    <div>{{scope.row.attestation == 1?'已认证':'未认证'}}</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="bindMachineNum" label="绑定机器" ></el-table-column>
            <el-table-column  prop="createdAt" label="注册时间">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="distributorName" label="绑定经销商" ></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                <el-button size="mini" type="text" v-preventReClick @click="editMchid(scope.row)">修改商户号</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editMchidFlag" width="30%" @click="editMchidFlag = false">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="商户号">
                <el-input size="small" v-model="mchid" style="width:230px" auto-complete="off" placeholder="请输入商户号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editMchidFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="商家详情" :visible.sync="detailsFlag" width="30%" @click="closeDialog">
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="基本信息" name="information">
                    <el-descriptions :column="1">
                        <el-descriptions-item label="商家名称">{{ editForm.nickname }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{ editForm.phone }}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ editForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="绑定经销商">{{ editForm.distributorName }}</el-descriptions-item>
                        <el-descriptions-item label="绑定经销商员工">{{ editForm.staffName }}</el-descriptions-item>
                        <el-descriptions-item label="分成比例">商家将从订单收益中（扣完手续费）分得{{ editForm.division }}%</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <el-tab-pane label="认证信息" name="attestation">
                    <el-switch
                        v-model="status"
                        active-text="已认证"
                        inactive-text="未认证"
                        :active-value="1"
                        :inactive-value="0"
                        @change="authenticaChange"
                        >
                        </el-switch>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="绑定机器" :visible.sync="bindingFlag" width="40%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
                    <el-form-item label="主屏id">
                        <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="machineData" max-height="400" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  type="selection" width="55"></el-table-column>
                    <el-table-column  prop="主屏id" label="主屏id" ></el-table-column>
                    <el-table-column  prop="机器状态" label="机器状态" ></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">添加</el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadBusinessUserList , loadCustomerList , authentica , setmchid } from '../../../api/userMG'
export default {
    data(){
        return{
            editMchidFlag:false,
            mchid:'',
            editMchidForm:{},
            editFlag:false,
            rules:{},
            loading:false,
            status:false,
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        submitForm(){
            setmchid({
                businessid:this.editMchidForm.id,
                mchid:this.mchid,
            }).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else {
                    this.editMchidFlag = false
                    this.$message.success('修改成功')
                    this.getdata()
                }
            })
        },
        editMchid(row){
            this.editMchidFlag = true
            this.mchid = row.mchid
            this.editMchidForm = row
        },
        authenticaChange(e){
            authentica({
                status:e,
                id:this.editForm.id
            }).then(res=>{
                if(!res.success){
                    this.$message.error(res.messages)
                }else {
                    this.$message.success('修改成功')
                    this.getdata()
                }
            })
        },  
        handleEdit(index , row){
            this.activeName = "information"
            this.detailsFlag = true
            this.status = row.attestation
            this.editForm = row
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadBusinessUserList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                name:this.formInline.name,
                phone:this.formInline.phone,
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/MerchantManagement/business.vue